import { Controller } from '@hotwired/stimulus'

const pathLabel = {
  '/browse': 'Browse & Search',
  '/similarity-search': 'AI Similarity Search',
  '/playlists': 'Marmoset Playlists',
  '/my_playlists': 'My Playlists',
  '/favorites': 'My Favorites'
}

export default class extends Controller {
  static targets = ['menu', 'toggleText']

  toggle(event) {
    event.preventDefault()
    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle('open')
    }
  }

  select(event) {
    const selectedText = event.target.textContent.trim()
    if (this.hasToggleTextTarget) {
      this.toggleTextTarget.textContent = selectedText
    }
    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove('open')
    }
  }

  closeOnOutsideClick = (event) => {
    if (!this.element.contains(event.target) && this.hasMenuTarget) {
      this.menuTarget.classList.remove('open')
    }
  }

  updateTextBasedOnPath() {
    const path = window.location.pathname
    const selectedText = pathLabel[path] || 'Browse & Search'

    if (this.hasToggleTextTarget) {
      this.toggleTextTarget.textContent = selectedText
    }
  }

  connect() {
    document.addEventListener('click', this.closeOnOutsideClick)
    this.updateTextBasedOnPath()
  }

  disconnect() {
    document.removeEventListener('click', this.closeOnOutsideClick)
  }
}
